export default "skymp5-front/b759a533484ca130da2b79427a39fdcc.png";